import React from 'react'

export const FEATURES = {
	home: React.lazy(() => import('~/features/home')),
	/** @deprecated Will remove soon */
	activation: React.lazy(() => import('~/features/care-activation')),
	signup: React.lazy(() => import('~/features/care-signup')),
	'popular-cities': React.lazy(() => import('~/features/care-popular-cities')),
	'find-job': React.lazy(() => import('~/features/care-find-job')),
	'edit-filter-job': React.lazy(() => import('~/features/care-edit-filter-job')),
	'urgent-needs': React.lazy(() => import('~/features/urgent-needs')),
	'explore-matches': React.lazy(() => import('~/features/explore-matches')),
	'trending-jobs': React.lazy(() => import('~/features/trending-jobs')),
	discover: React.lazy(() => import('~/features/discover')),
	'my-jobs': React.lazy(() => import('~/features/my-jobs')),
	credential: React.lazy(() => import('~/features/care-credential')),
	'skill-checklists': React.lazy(() => import('~/features/care-credential/components/checklists')),
	jobs: React.lazy(() => import('~/features/care-jobs')),
	benefits: React.lazy(() => import('~/features/care-benefits')),
	referrer: React.lazy(() => import('~/features/care-referral')),
	'referral-traveller': React.lazy(() => import('~/features/care-referral-traveller')),
	'contact-us': React.lazy(() => import('~/features/care-contact-us')),
	settings: React.lazy(() => import('~/features/care-settings')),
	'job-results': React.lazy(() => import('~/features/care-job-results')),
	'list-jobs': React.lazy(() => import('~/features/care-list-jobs')),
	'last-viewed': React.lazy(() => import('~/features/last-viewed')),
	bookmark: React.lazy(() => import('~/features/bookmark')),
	'job-alerts': React.lazy(() => import('~/features/job-alerts')),
	'sign-out': React.lazy(() => import('~/features/care-sign-out')),
	// 'email-unsubscribe': React.lazy(() => import('~/features/care-email-unsubscribe')),
	'profile-completion': React.lazy(() => import('~/features/profile-completion')),
	'verify-credential': React.lazy(() => import('~/features/care-verify-credential')),

	// COMMON FEATURES
	signin: React.lazy(() => import('~/features/common-signin')),
	messages: React.lazy(() => import('~/features/care-messages')),
	errors: React.lazy(() => import('~/features/common-errors')),
	reset: React.lazy(() => import('~/features/common-reset')),
	'update-phone': React.lazy(() => import('~/features/common-update-phone')),
	'change-password': React.lazy(() => import('~/features/common-change-password')),
	'link-account': React.lazy(() => import('~/features/common-link-account')),
	'link-options': React.lazy(() => import('~/features/common-link-options')),

	'common-sso': React.lazy(() => import('~/features/common-single-sign-on')),

	profile: React.lazy(() => import('~/features/care-profile')),

	// TRACKING FEATURES
	'utm-tracking': React.lazy(() => import('~/features/utm-tracking')),
}
